module.exports = __webpack_public_path__ + "img/order-info.2e81c790.svg";